import React, { HTMLAttributes, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import cx from "classnames";
import { Hooks, Util } from "@xt/xtbase";
const { useTranslation } = Hooks;
const { getUrl } = Util;
import store from "store";
import { filterBigNumThousands } from "utils/method";

import { Tooltip } from "antd";
import XtFontScale from "components/xt/fontScale";
import XtSvg from "components/xt/svg";
import usePriceCurrencyConvert from "hooks/usePriceCurrencyConvert";
import useUpDownClassTicker from "hooks/useUpDownClassTicker";

import styles from "./index.module.scss";

const Main: React.FC<HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => {
  const router = useRouter();
  const t = useTranslation();

  const { name, netWorth, isEtf, isLever } = store.market;
  const { tradeRecent } = store.trade;

  // console.log("tradeRecent====", tradeRecent);
  // const priceCls = useUpDownClassTicker(tradeRecent, true);
  const tickerShadow = useMemo(() => {
    if (!tradeRecent) return;
    return {
      s: name,
      c: tradeRecent.p,
      cv: tradeRecent.b ? "1" : "-1",
    };
  }, [tradeRecent]);
  const priceCls = useUpDownClassTicker(tickerShadow);
  const priceLab = useMemo(() => {
    if (!tradeRecent) return "--";
    return filterBigNumThousands(tradeRecent.p);
    // return filterBigNumThousands(tradeRecent.p, currentConfig.pricePrecision);
  }, [tradeRecent]);
  // }, [tradeRecent, currentConfig]);
  const currentPriceConvert = usePriceCurrencyConvert({ value: tradeRecent ? tradeRecent.p : 0 });

  const tradeMoreUrl = useMemo(() => {
    return `/${router.locale}/trade-order/${name}` + (isLever ? "?type=margin" : "");
  }, [router.locale, name, isLever]);

  return (
    <div className={cx(styles.main, className)} {...rest}>
      <XtFontScale className={styles.leftCon} isLoop={true}>
        <b className={priceCls}>{priceLab}</b>
        <span className={cx(styles.arrow, priceCls)}>
          <XtSvg icon={"arrow-down"} />
        </span>
        {!isEtf && <small>{currentPriceConvert}</small>}
      </XtFontScale>
      <div className={styles.rightCon}>
        {isEtf && !!netWorth && (
          <Tooltip placement="topRight" getPopupContainer={(triggerNode: HTMLElement) => triggerNode} title={t("trade.etfNetTip")}>
            <div className={cx(styles.etfTip)}>
              <span>{t("trade.etfNet")}</span>
              <u>{netWorth}</u>
            </div>
          </Tooltip>
        )}

        <a href={tradeMoreUrl}>{t("trade.more")}</a>
      </div>
    </div>
  );
};

export default observer(Main);
